import ReactCountryFlag from 'react-country-flag';
import {useCountries} from 'api/countries';
import styles from './CountryFlag.module.sass';

interface ICountryFlagProps {
    code?: string;
    title?: boolean;
}

const CountryFlag: React.FC<ICountryFlagProps> = ({code, title = true}) => {
    const {countries} = useCountries();

    const getCountry = () => {
        const current = countries.find(country => country['@id'] === code);
        return current?.name;
    };

    const props = {
        countryCode: code?.split('/').pop()!,
        svg: true,
        styles: {
            width: '100%',
            height: '100%',
        },
    };

    return (
        <span className={styles.countryFlag}>
            <span className={styles.flag}>
                <ReactCountryFlag {...props} />
            </span>
            {title ? (
                <span className={styles.title}>{getCountry()}</span>
            ) : null}
        </span>
    );
};

export default CountryFlag;
